export const auth = {
  authHomeTitle: 'Lass uns starten',
  authHomeButtonBranded: 'Weiter mit E-Mail',
  authHomeButtonApple: 'Weiter mit Apple',
  authHomeButtonGoogle: 'Weiter mit Google',
  authHomeButtonFacebook: 'Weiter mit Facebook',
  authHomeButtonLinkedin: 'Weiter mit LinkedIn',
  authStartTitle: 'Anmelden oder Registrieren',
  authStartInputTitle: 'E-Mail',
  authStartInputTitleError: 'Bitte geben Sie eine gültige E-Mail-Adresse ein!',
  authStartInputPasswordError: 'Bitte geben Sie ein gültiges Passwort ein!',
  authWhoops: 'Hoppla!',
  authStartConfirmButton: 'Weiter',
  authRegisteredTitle: 'Willkommen zurück!',
  authStartPlaceholderTitle: 'E-Mail',
  authRegisteredInputTitle: 'Passwort',
  authRegisteredForgotPassword: 'Passwort vergessen',
  authAlertIncorrectPassword: 'Ihre E-Mail-Adresse oder Ihr Passwort ist falsch',
  authAlertRequiredPassword: 'Bitte geben Sie ein gültiges Passwort ein',
  authFinishSignUpTitle: 'Registrierung abschließen',
  authFinishSignUpEmailInputTitle: 'E-Mail',
  authFinishSignUpFirstNameInputTitle: 'Vorname',
  authFinishSignUpLastNameInputTitle: 'Nachname',
  authFinishSignUpPasswordInputTitle: 'Passwort',
  authFinishSignUpTipContent:
    '<ul class="text-14 pl-4 text-black"><li class="-ml-4 list-none">Wir empfehlen die Verwendung von:</li><li class="list-disc">Mindestens 8 Zeichen</li><li class="list-disc">Enthält 1 Nummer</li><li class="list-disc">Enthält 1 Sonderzeichen</li></ul>',
  authFinishSignUpPrivacyAndTerms: {
    text1: 'Durch Klicken auf Registrieren stimmen Sie unseren',
    privacyPolicy: 'Datenschutzbestimmungen',
    text2: 'und',
    termsOfUse: 'Nutzungsbedingungen'
  },
  authFinishSignUpConfirmButton: 'Registrieren',
  authFinishSignUpErrorFirstName: 'Der Vorname darf nicht leer sein!',
  authFinishSignUpErrorLastName: 'Der Nachname darf nicht leer sein!',
  authFinishSignUpErrorPassword: 'Das Passwort ist zu kurz!',
  authEmailConfirmationTitle: 'Überprüfen Sie Ihr Postfach',
  authEmailConfirmationContent:
    'Wir haben eine Bestätigungs-E-Mail gesendet, um Ihre E-Mail-Adresse zu bestätigen. Bitte überprüfen Sie auch Ihren Spam-Ordner, falls Sie sie nicht in Ihrem Posteingang finden.',
  authEmailConfirmationConfirmButton: 'Zurück zur Anmeldung',
  authAlertEmailConfirmation: 'Bitte überprüfen Sie Ihren Posteingang, um Ihre E-Mail zu bestätigen!',
  authResetPasswordTitle: 'Überprüfen Sie Ihr Postfach',
  authResetPasswordDescription:
    'Wir haben einen Link zum Zurücksetzen Ihres Passworts an Ihre E-Mail-Adresse gesendet. Bitte überprüfen Sie auch Ihren Spam-Ordner, falls Sie ihn nicht in Ihrem Posteingang finden.',
  authResetPasswordButton: 'Zurück zur Anmeldung',
  authNewPasswordTitle: 'Neues Passwort eingeben',
  authNewPasswordInputTitle: 'Neues Passwort',
  authNewPasswordButton: 'Passwort zurücksetzen',
  authNewPasswordAlertValidation: 'Ihr Passwort ist nicht stark genug',
  authPasswordChangeSuccessTitle: 'Passwort geändert!',
  authPasswordChangeSuccessContent: 'Ihr Passwort wurde erfolgreich geändert!',
  authPasswordChangeSuccessButton: 'Zurück zur Anmeldung',
  authPasswordChangeErrorTitle: 'Fehler!',
  authPasswordChangeErrorContent:
    'Beim Versuch, Ihr Passwort zurückzusetzen, ist ein Fehler aufgetreten! Bitte versuchen Sie es später erneut.',
  authPasswordChangeErrorButton: 'Zurück zur Anmeldung',
  authInvitationTitle: 'Wählen Sie ein Passwort',
  authInvitationInputTitle: 'Passwort',
  authInvitationButton: 'Passwort einrichten',
  authEmailAddressConfirmed: 'E-Mail-Adresse bestätigt!'
}
